export const reportFieldLabels = {
    resultPO: {
        examPlan: "План осмотра",
        examinedTotal: "Осмотрено всего",
        recommendedDispensary: "Рекомендовано к постановке на диспансерный учет",
        recommendedHospitalization: "Рекомендована госпитализация в стационар",
        recommendedSurgery: "Рекомендовано хирургическое лечение",
        recommendedFederalTreatment: "Рекомендовано лечение в Федеральном центре",
        recommendedTelemedWithFC: "Рекомендовано ТМК с ФЦ",
        diagnosesTotal: "Установлено диагнозов",
        firstTimeDiagnoses: "Установлено диагнозов впервые в жизни",
    },
    resultPOChildren: {
        registeredDispensary: "Поставлено на диспансерный учет",
        hospitalized: "Госпитализировано в стационар (местный/вне региона)",
        surgeryPerformed: "Выполнено хирургическое лечение",
        referredToFederalCenter: "Направлено в Федеральный центр на лечение",
        telemedWithFCPerformed: "Выполнено ТМК с ФЦ"
    }
};
